export default {
  ad_type: {
    tv: {},
    radio: {},
    print: {},
    online_video: {},
    online_display: {}
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/scorecard/MetricsLabels/index.js